const master = {
  cara_pengumpulan_data: [
    { id: 1, enum: "PENCACAHAN_LENGKAP", value: "Pencacahan Lengkap" },
    { id: 2, enum: "SURVEI", value: "Survei" },
    {
      id: 3,
      enum: "KOMPILASI_PRODUK_ADMINISTRASI",
      value: "Kompilasi Produk Administrasi",
    },
    {
      id: 4,
      enum: "CARA_LAIN_SESUAI_DENGAN_PERKEMBANGAN_TI",
      value: "Cara lain sesuai dengan perkembangan TI",
    },
  ],
  sektor_kegiatan: [
    {
      id: 1,
      enum: "PERTANIAN_DAN_PERIKANAN",
      value: "Pertanian dan Perikanan",
    },
    {
      id: 2,
      enum: "DEMOGRAFI_DAN_KEPENDUDUKAN",
      value: "Demografi dan Kependudukan",
    },
    { id: 3, enum: "PEMBANGUNAN", value: "Pembangunan" },
    { id: 4, enum: "PROYEKSI_EKONOMI", value: "Proyeksi Ekonomi" },
    {
      id: 5,
      enum: "PENDIDIKAN_DAN_PELATIHAN",
      value: "Pendidikan dan Pelatihan",
    },
    { id: 6, enum: "LINGKUNGAN", value: "Lingkungan" },
    { id: 7, enum: "KEUANGAN", value: "Keuangan" },
    { id: 8, enum: "GLOBALISASI", value: "Globalisasi" },
    { id: 9, enum: "KESEHATAN", value: "Kesehatan" },
    { id: 10, enum: "INDUSTRI_DAN_JASA", value: "Industri dan Jasa" },
    {
      id: 11,
      enum: "TEKNOLOGI_INFORMASI_DAN_KOMUNIKASI",
      value: "Teknologi Informasi dan Komunikasi",
    },
    {
      id: 12,
      enum: "PERDAGANGAN_INTERNASIONAL_DAN_NERACA_PERDAGANGAN",
      value: "Perdagangan Internasional dan Neraca Perdagangan",
    },
    { id: 13, enum: "KETENAGAKERJAAN", value: "Ketenagakerjaan" },
    { id: 14, enum: "NERACA_NASIONAL", value: "Neraca Nasional" },
    {
      id: 15,
      enum: "INDIKATOR_EKONOMI_BULANAN",
      value: "Indikator Ekonomi Bulanan",
    },
    { id: 16, enum: "PRODUKTIVITAS", value: "Produktivitas" },
    {
      id: 17,
      enum: "HARGA_DAN_PARITAS_DAYA_BELI",
      value: "Harga dan Paritas Daya Beli",
    },
    {
      id: 18,
      enum: "SEKTOR_PUBLIK_PERPAJAKAN_DAN_REGULASI_PASAR",
      value: "Sektor Publik, Perpajakan, dan Regulasi Pasar",
    },
    {
      id: 19,
      enum: "PERWILAYAHAN_DAN_PERKOTAAN",
      value: "Perwilayahan dan Perkotaan",
    },
    {
      id: 20,
      enum: "ILMU_PENGETAHUAN_DAN_HAK_PATEN",
      value: "Ilmu Pengetahuan dan Hak Paten",
    },
    {
      id: 21,
      enum: "PERLINDUNGAN_SOSIAL_DAN_KESEJAHTERAAN",
      value: "Perlindungan Sosial dan Kesejahteraan",
    },
    { id: 22, enum: "TRANSPORTASI", value: "Transportasi" },
  ],
  kegiatan_ini_dilakukan: [
    { id: 1, enum: "HANYA_SEKALI", value: "Hanya Sekali" },
    { id: 2, enum: "BERULANG", value: "Berulang" },
  ],
  frekuensi_penyelanggara: [
    { id: 1, enum: "HARIAN", value: "Harian" },
    { id: 2, enum: "MINGGUAN", value: "Mingguan" },
    { id: 3, enum: "BULANAN", value: "Bulanan" },
    { id: 4, enum: "TRIWULANAN", value: "Triwulanan" },
    { id: 5, enum: "EMPAT_BULANAN", value: "Empat Bulanan" },
    { id: 6, enum: "SEMESTERAN", value: "Semesteran" },
    { id: 7, enum: "TAHUNAN", value: "Tahunan" },
    { id: 8, enum: "LEBIH_DARI_DUA_TAHUNAN", value: "Lebih dari Dua Tahunan" },
  ],
  tipe_pengumpulan_data: [
    { id: 1, enum: "LONGITUDINAL_PANEL", value: "Longitudinal Panel" },
    { id: 2, enum: "CROSS_SECTIONAL", value: "Cross Sectional" },
    {
      id: 3,
      enum: "LONGITUDINAL_CROSS_SECTIONAL",
      value: "Longitudinal Cross Sectional",
    }
  ],
  cakupan_wilayah_pengumpulan_data: [
    {
      id: 1,
      enum: "SELURUH_WILAYAH_INDONESIA",
      value: "Seluruh Wilayah Indonesia",
    },
    {
      id: 2,
      enum: "SEBAGIAN_WILAYAH_INDONESIA",
      value: "Sebagian Wilayah Indonesia",
    },
  ],
  metode_pengumpulan_data: [
    { id: 1, enum: "WAWANCARA", value: "Wawancara" },
    {
      id: 2,
      enum: "MENGISI_KUESIONER_SENDIRI_ATAU_SWACACAH",
      value: "Mengisi kuesioner sendiri (swacacah)",
    },
    {
      id: 4,
      enum: "PENGAMATAN_ATAU_OBSERVASI",
      value: "Pengamatan (observasi)",
    },
    {
      id: 8,
      enum: "PENGUMPULAN_DATA_SEKUNDER",
      value: "Pengumpulan data sekunder",
    },
    { id: 16, enum: "LAINNYA", value: "Lainnya" },
  ],
  sarana_pengumpulan_data: [
    {
      id: 1,
      enum: "PAPER_ASSISTED_PERSONAL_INTERVIEWING_ATAU_PAPI",
      value: "Paper-assisted Personal Interviewing (PAPI)",
    },
    {
      id: 2,
      enum: "COMPUTER_ASSISTED_PERSONAL_INTERVIEWING_ATAU_CAPI",
      value: "Computer-assisted Personal Interviewing (CAPI)",
    },
    {
      id: 4,
      enum: "PAPER_ASSISTED_TELEPHONES_INTERVIEWING_ATAU_CATI",
      value: "Computer-assisted Telephones Interviewing (CATI)",
    },
    {
      id: 8,
      enum: "PAPER_AIDED_WEB_INTERVIEWING_ATAU_CAWI",
      value: "Computer Aided Web Interviewing (CAWI)",
    },
    { id: 16, enum: "MAIL", value: "Mail" },
    { id: 32, enum: "LAINNYA", value: "Lainnya" },
  ],
  unit_pengumpulan_data: [
    { id: 1, value: "Individu" },
    { id: 2, value: "Rumah Tangga" },
    { id: 4, value: "Usaha/perusahaan" },
    { id: 8, value: "Lainnya" },
  ],
  jenis_rancangan_sampel: [
    { id: 1, enum: "SINGLE_STAGE_ATAU_PHASE", value: "Single Stage/Phase" },
    { id: 2, enum: "MULTI_STAGE_ATAU_PHASE", value: "Multi Stage/Phase" },
  ],
  metode_pemilihan_sampel_terakhir: [
    { id: 1, enum: "SAMPEL_PROBABILITAS", value: "Sampel Probabilitas" },
    { id: 2, enum: "SAMPEL_NONPROBABILITAS", value: "Sampel Nonprobabilitas" },
  ],
  metode_yang_digunakan_probabilitas: [
    { id: 1, enum: "SIMPLE_RANDOM_SAMPLING", value: "Simple Random Sampling" },
    {
      id: 2,
      enum: "SYSTEMATIC_RANDOM_SAMPLING",
      value: "Systematic Random Sampling",
    },
    {
      id: 3,
      enum: "STRATIFIED_RANDOM_SAMPLING",
      value: "Stratified Random Sampling",
    },
    { id: 4, enum: "CLUSTER_SAMPLING", value: "Cluster Sampling" },
    { id: 5, enum: "MULTI_STAGE_SAMPLING", value: "Probability Proportional To Size Sampling" },
  ],
  metode_yang_digunakan_nonprobabilitas: [
    { id: 6, enum: "QUOTA_SAMPLING", value: "Quota Sampling" },
    { id: 7, enum: "ACCIDENTAL_SAMPLING", value: "Accidental Sampling" },
    { id: 8, enum: "PURPOSIVE_SAMPLING", value: "Purposive Sampling" },
    { id: 9, enum: "SNOWBALL_SAMPLING", value: "Snowball Sampling" },
    { id: 10, enum: "SATURATION_SAMPLING", value: "Saturation Sampling" },
  ],
  kerangka_sampel_tahap_terakhir: [
    { id: 1, enum: "LIST_FRAME", value: "List Frame" },
    { id: 2, enum: "AREA_FRAME", value: "Area Frame" },
  ],
  apakah_melakukan_uji_coba: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  metode_pemeriksaan_kualitas_pengumpulan_data: [
    {
      id: 1,
      enum: "KUNJUNGAN_KEMBALI_ATAU_REVISIT",
      value: "Kunjungan kembali (revisit)",
    },
    { id: 2, enum: "SUPERVISI", value: "Supervisi" },
    { id: 4, enum: "TASK_FORCE", value: "Task Force" },
    { id: 8, enum: "LAINNYA", value: "Lainnya" },
  ],
  apakah_melakukan_penyesuaian_nonrespon: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  petugas_pengumpulan_data: [
    {
      id: 1,
      enum: "STAF_INSTANSI_PENYELENGGARA",
      value: "Staf instansi penyelenggara",
    },
    { id: 2, enum: "MITRA_ATAU_TENAGA_KONTRAK", value: "Mitra/tenaga kontrak" },
    {
      id: 3,
      enum: "STAF_INSTANSI_PENYELENGGARA_DAN_MITRA_ATAU_TENAGA_KONTRAK",
      value: "Staf instansi penyelenggara dan mitra/tenaga kontrak",
    },
  ],
  persyaratan_pendidikan_terendah_petugas_pengumpulan_data: [
    { id: 1, enum: "KURANG_DARI_ATAU_SAMA_DENGAN_SMP", value: "SMP Sederajat atau Dibawahnya" },
    { id: 2, enum: "SMA_ATAU_SMK", value: "SMA/SMK Sederajat" },
    { id: 3, enum: "DIPLOMA_I_ATAU_II_ATAU_III", value: "Diploma I/II/III" },
    {
      id: 4,
      enum: "DIPLOMA_IV_ATAU_S1_ATAU_S2_ATAU_S3",
      value: "Diploma IV/S1/S2/S3",
    },
  ],
  apakah_melakukan_pelatihan_petugas: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  editing: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  coding: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  entry: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  validasi: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  metode_analisis: [
    { id: 1, enum: "DESKRIPTIF", value: "Deskriptif" },
    { id: 2, enum: "INFERENSIA", value: "Inferensia" },
    {
      id: 3,
      enum: "DESKRIPTIF_DAN_INFERENSIA",
      value: "Deskriptif dan Inferensia",
    },
  ],
  unit_analsis: [
    { id: 1, value: "Individu" },
    { id: 2, value: "Rumah Tangga" },
    { id: 4, value: "Usaha/perusahaan" },
    { id: 8, value: "Lainnya" },
  ],
  tingkat_penyajian_hasil_analisis: [
    { id: 1, value: "Nasional" },
    { id: 2, value: "Provinsi" },
    { id: 4, value: "Kabupaten/Kota" },
    { id: 8, value: "Kecamatan" },
    { id: 16, value: "Lainnya" },
  ],
  tercetak: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  digital: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
  data_mikro: [
    { id: 1, value: "Ya" },
    { id: 2, value: "Tidak" },
  ],
};
export default master;
